import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';
import { branch, renderNothing, compose } from 'recompose';

import { containerApp } from '../../../main';
import registerIcon from '../../../../images/register.svg';

const RegisterButton = props => (
  <Link to={props.url} className="c-btn c-btn--register-opener" data-automation-id="link:openRegister">
    <img src={registerIcon} alt="Register" />
  </Link>
);

RegisterButton.propTypes = {
  url: PropTypes.string.isRequired,
};

export default compose(
  withRouter,
  branch(
    (props) => {
      const shouldShowRegister = !props.location.pathname.startsWith(props.url);
      return !shouldShowRegister;
    },
    renderNothing,
  ),
  containerApp.hideForContainerApp,
)(RegisterButton);
